export default class InvestmentFootprint {

    constructor() {

        this.settings = {
            $map: $('#map-pins')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        if(this.settings.$map.length !== 0) {
            let geocoder, map;
            let defaultLat = $('.js-map-pins-lat').data('default-lat');
            let defaultLng = $('.js-map-pins-lng').data('default-lng');
            const pin = $('#map-pins-marker').attr('src');

            // Basic map setup
            function initialize() {
                geocoder = new google.maps.Geocoder();
                let centerMap = new google.maps.LatLng(defaultLat, defaultLng);

                let mapOptions = {
                    zoom: 8,
                    center: centerMap,
                }

                map = new google.maps.Map(document.getElementById('map-pins'), mapOptions);

                let addresses = $('.js-map-pins-address');
                let addressArray = addresses.toArray();

                addressArray.forEach((address) => {

                    let addressLat = address.getAttribute('data-map-lat');
                    let addressLng = address.getAttribute('data-map-lng');

                    new google.maps.Marker({
                        position: {lat: Number(addressLat), lng: Number(addressLng)},
                        map,
                        icon: pin,
                        animation: google.maps.Animation.DROP
                    });

                });

            }

            function drop() {
                setTimeout(function() {
                    addMarker();
                },200);
            }

            $(window).on('load', function(){
                initialize();
            });
        }

    }
}

new InvestmentFootprint();